export const handlePermissionsUserSelect = (permissions) => ({
  type: 'HANDLE-PERMISSIONS-USER-SELECT',
  payload: permissions,
});
export const handleEmptyPermissions = () => ({
  type: 'HANDLE-EMPTY-PERMISSIONS',
});
